import { api } from "@/lib/api";

export const getProductAccess = async (productSlug) =>
  (await api.get(`/product-access/${encodeURIComponent(productSlug)}`)).data;
